import { z } from "zod";
export const SubscriptionIntervalSchema = z.enum(["month", "year", "lifetime"]);
export const SubscriptionVendorSchema = z.enum(["scrolller", "patreon"]);
